import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'durationInDays',
  standalone: true,
})
export class DurationInDaysPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): number | null {
    if (value === null) return null;
    const secondes = value;
    const divider = 8 * 60 * 60;

    return Number((secondes / divider).toFixed(1));
  }
}
